import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "1196",
  height: "528.59601",
  viewBox: "0 0 1196 528.59601",
  version: "1.1",
  id: "svg3",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:svg": "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  id: "g1",
  transform: "translate(-20,-10)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "m 1216,171.912 c -79.2,3.649 -112.25,28.776 -148.11,56.043 -31.82,24.191 -65.85,50.066 -136.288,64.119 -53.579,10.699 -90.145,6.287 -122.383,2.397 -38.192,-4.608 -70.305,-8.483 -117.426,14.369 -37.172,18.041 -55.07,48.56 -72.762,78.728 -23.668,40.358 -46.965,80.088 -115.547,88.485 -59.937,7.336 -99.207,-9.268 -138.476,-25.873 -39.27,-16.606 -78.543,-33.213 -138.485,-25.875 -55.73,6.82 -72.734,30.576 -90.023,54.728 C 116.918,506.387 96.9727,534.248 20,538.596 V 10 h 1196 z",
    id: "path1"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }